import React from 'react';
import { JobItemType } from 'scenes/jobs/mocks/mock_job_items';
import './JobTypeCell.scss';

export interface JobTypeCellProps {
  type: JobItemType;
}

export const JobTypeCell: React.FC<JobTypeCellProps> = ({ type }) => {
  const classes = ['job-type-cell'];

  if (type !== 'Custom') {
    classes.push('job-type-cell--highlighted');
  }

  return <div className={classes.join(' ')}>{type}</div>;
};
